<template>
  <div class="form-photos">
    <ion-button @click="openPhotosModal" fill="clear">
      <ion-icon slot="start" name="camera" />
      <span>Take Photo</span>
    </ion-button>
    <photos-gallery :files="photos" />
  </div>
</template>

<script>
import PhotosModal from "../PhotosModal.vue";
import PhotosGallery from "../PhotosGallery.vue";

export default {
  name: "FormPhotos",
  components: {
    PhotosGallery
  },
  props: {
    value: Array,
    properties: Object
  },
  computed: {
    photos: {
      get() {
        return this.value || [];
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    openPhotosModal() {
      const onPhotos = function(value) {
        this.photos = value;
      }.bind(this);
      return this.$ionic.modalController
        .create({
          component: PhotosModal,
          componentProps: {
            propsData: {
              data: this.photos,
              onPhotos
            }
          }
        })
        .then(modal => modal.present());
    }
  }
};
</script>
